// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /season/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeSeasonListBody,
  typeSeasonListOutput200,
} from "../../sdk/season/postSeasonList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildSeasonListQueryKey(payload: typeSeasonListBody): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  return ["post:season:seasonList", "svc:contest-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeSeasonListOutput200,
    unknown,
    typeSeasonListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useSeasonList(
  payload: typeSeasonListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildSeasonListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postSeasonList(payload),
    ...resolvedOptions,
  });
}
